import { render, staticRenderFns } from "./PublicFooter.vue?vue&type=template&id=0f141394&scoped=true&"
import script from "./PublicFooter.vue?vue&type=script&lang=ts&"
export * from "./PublicFooter.vue?vue&type=script&lang=ts&"
import style0 from "./PublicFooter.vue?vue&type=style&index=0&id=0f141394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f141394",
  null
  
)

export default component.exports